<template>
	<div
		class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-2"
	>
		<div
			class="flex flex-wrap lg:flex-nowrap gap-y-4 md:space-y-0 justify-start items-center mb-4 gap-x-6"
		>
			<!-- create new offer button -->
			<ui-button
				class="order-1 flex items-center flex-shrink-0"
				v-on:click="$bus.$emit('toggle-iframe-modal', $route('offers.create'))"
			>
				<ui-icon
					class="hidden sm:inline-block mr-2 -ml-1 flex-shrink-0 h-5 w-5 text-white"
					name="plus"
					stroke-width="2"
				/>
				<span class="">{{ __("New Offer") }}</span>
			</ui-button>

			<!-- info text -->
			<p class="order-3 lg:order-2 text-gray-500">
				{{
					__(
						"List now simply and free of charge. The listings can be managed here."
					)
				}}
			</p>

			<!-- legend
            <div class="order-2 lg:order-3 flex gap-x-6 ml-auto">
                <div class="whitespace-nowrap">
                    <div class="inline-block align-text-bottom sm:border-2 bg-orange-500 sm:bg-transparent sm:border-orange-500 w-5 h-5 mr-1"></div>
                    {{ __('Buy Offers') }}
                </div>
                <div class="whitespace-nowrap">
                    <div class="inline-block align-text-bottom sm:border-2 bg-green-500 sm:bg-transparent sm:border-green-500 rounded-full w-5 h-5 mr-1"></div>
                    {{ __('Sell Offers') }}
                </div>
            </div>-->
		</div>

		<div class="flex-grow flex flex-col space-y-4 mb-4">
			<my-lots-card
				v-for="offer in filteredOffers"
				:offer="offer"
				:key="offer.trade + offer.id"
				:priceIndicationStat="
					priceIndicationStats ? priceIndicationStats[offer.id] : null
				"
				:activeFutures="activeFutures"
				:auction="auction"
				:auctionMyLotsState="auctionMyLotsState"
				:piEndOfDay="piEndOfDay"
				:piShowButton="piShowButton"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		filteredOffers: {
			type: Array,
			required: true,
		},
		priceIndicationStats: {
			type: Object,
			required: false,
		},
		activeFutures: {
			type: Array,
			required: false,
		},
		auction: {
			type: Object,
			required: false,
			default: null,
		},
		auctionMyLotsState: {
			type: String,
			required: true,
		},
		piEndOfDay: {
			type: Boolean,
			required: false,
			default: false,
		},
		piShowButton: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
};
</script>
